// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__2A7N7","topButton":"topButton__VhcsU","button":"button__1w-pb","rightColumn":"rightColumn__2SJmG"};